"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Tue Jun 26 2018
 */

var CodebookLookupSequence_1 = require("../../core/model/codebook/CodebookLookupSequence");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * WorkflowCaseInfo represents domain object describing workflow case
 *
 * @author VBr
 */


var WorkflowCaseInfo =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(WorkflowCaseInfo, _DomainObject_1$Domai);

  /**
   * Constructs product instance.
   *
   * @param id the internal id of product
   * @param wflowId workflow id
   * @param assignee assigned user
   * @param state workflow state
   * @param terminated whether the case is active
   * @param entity Name of the domain entity/entities workflow case relates to
   */
  function WorkflowCaseInfo(id, wflowId, assignee, state, terminated, entity) {
    var _this;

    _classCallCheck(this, WorkflowCaseInfo);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WorkflowCaseInfo).call(this));
    _this.id = id;
    _this.wflowId = wflowId;
    _this.assignee = assignee;
    _this.state = state;
    _this.terminated = terminated;
    _this.entity = entity;
    return _this;
  }

  return WorkflowCaseInfo;
}(DomainObject_1.DomainObject);

exports.WorkflowCaseInfo = WorkflowCaseInfo;
/**
 * lookup sequence used in UI to retrieve workflow cases
 */

WorkflowCaseInfo.DEFINITION_LOOKUP = CodebookLookupSequence_1.CodebookLookupSequence.WorkflowDefinition;
WorkflowCaseInfo.CASE_LOOKUP = CodebookLookupSequence_1.CodebookLookupSequence.WorkflowCase; // tslint:disable-next-line:member-ordering

WorkflowCaseInfo.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(WorkflowCaseInfo.name);
  return {
    id: builder.lookup('id', WorkflowCaseInfo.CASE_LOOKUP),
    wflowId: builder.lookup('wflowId', WorkflowCaseInfo.DEFINITION_LOOKUP),
    assignee: builder.opt(builder.str('assignee')),
    state: builder.str('state'),
    terminated: builder.bool('terminated'),
    entity: builder.opt(builder.str('entity'))
  };
}();